import { Component, Inject } from '@angular/core';

// libs
import { BaseComponent } from '@moduurnv2/libs-orderingapp/src/core';

export abstract class AppBaseComponent extends BaseComponent {
  /**
   * Define common root app component behavior for all web apps here
   */
}
